import { InterphaceCoreBase } from "./interphace.core.base"


export class InterphaceCore extends InterphaceCoreBase {

}